
import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { Button } from "../components/ui/button";
import SocialShare from "../components/shared/SocialShare";
import PageLayout from "../components/shared/PageLayout";
import { toast } from "sonner";

const ViewFortune = () => {
  const [searchParams] = useSearchParams();
  const [fortune, setFortune] = useState<string>("");

  useEffect(() => {
    const fortuneMessage = searchParams.get("message");
    if (fortuneMessage) {
      try {
        // Decode the fortune message from URI encoding
        const decodedFortune = decodeURIComponent(fortuneMessage);
        setFortune(decodedFortune);
      } catch (error) {
        console.error("Error decoding fortune message:", error);
        toast.error("Could not load the fortune message");
      }
    }
  }, [searchParams]);

  return (
    <>
      <Helmet>
        <title>Fortune Message | Custom Fortune Cookie Message</title>
        <meta 
          name="description" 
          content="View a custom fortune cookie message created by someone special." 
        />
        <meta property="og:title" content="Fortune Cookie Message" />
        <meta 
          property="og:description" 
          content="View a fortune cookie message. Check it out!" 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="/view-fortune" />
        <meta property="og:image" content="/fortune-cookie-og.png" />
      </Helmet>

      <PageLayout>
        <motion.div 
          className="max-w-2xl mx-auto w-full mt-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-center">
            <h1 className="text-3xl font-light mb-8">Fortune Message</h1>
            
            {fortune ? (
              <div className="bg-secondary/50 p-6 rounded-xl border border-secondary">
                <div className="fortune-paper paper-texture p-6 rounded-lg inline-block mx-auto mb-8">
                  <p className="text-gray-700 italic font-light text-xl">{fortune}</p>
                </div>
                
                <div className="mt-6">
                  <SocialShare 
                    content={fortune}
                    title="Fortune Cookie Message"
                    showCopyButton={false}
                    showViewButton={false}
                  />
                </div>
              </div>
            ) : (
              <div className="bg-secondary/50 p-6 rounded-xl border border-secondary">
                <p className="text-muted-foreground">No fortune message was found.</p>
              </div>
            )}
            
            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-12">
              <Link to="/create-fortune">
                <Button className="w-full sm:w-auto bg-[#830300] hover:bg-[#830300]/90 text-white">
                  Create Your Own Fortune
                </Button>
              </Link>
              <Link to="/">
                <Button className="w-full sm:w-auto bg-cookie-dark hover:bg-cookie-light text-white">
                  Get Your Fortune Now
                </Button>
              </Link>
            </div>
          </div>
        </motion.div>
      </PageLayout>
    </>
  );
};

export default ViewFortune;
